var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9298 11.9335C14.714 12.1427 14.6148 12.4452 14.664 12.7418L15.4048 16.8418C15.4673 17.1893 15.3206 17.541 15.0298 17.7418C14.7448 17.9502 14.3656 17.9752 14.0548 17.8085L10.364 15.8835C10.2356 15.8152 10.0931 15.7785 9.94729 15.7743H9.72146C9.64313 15.786 9.56646 15.811 9.49646 15.8493L5.80479 17.7835C5.62229 17.8752 5.41563 17.9077 5.21313 17.8752C4.71979 17.7818 4.39063 17.3118 4.47146 16.816L5.21313 12.716C5.26229 12.4168 5.16313 12.1127 4.94729 11.9002L1.93813 8.9835C1.68646 8.73933 1.59896 8.37266 1.71396 8.04183C1.82563 7.71183 2.11063 7.471 2.45479 7.41683L6.59646 6.816C6.91146 6.7835 7.18813 6.59183 7.32979 6.3085L9.15479 2.56683C9.19813 2.4835 9.25396 2.40683 9.32146 2.34183L9.39646 2.2835C9.43563 2.24016 9.48063 2.20433 9.53063 2.17516L9.62146 2.14183L9.76313 2.0835H10.114C10.4273 2.116 10.7031 2.3035 10.8473 2.5835L12.6965 6.3085C12.8298 6.581 13.089 6.77016 13.3881 6.816L17.5298 7.41683C17.8798 7.46683 18.1723 7.7085 18.2881 8.04183C18.3973 8.376 18.3031 8.74266 18.0465 8.9835L14.9298 11.9335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f0785705deb5e88b593ee5ec2b2262cc.svg";
export { ForwardRef as ReactComponent };